import React, { useState, useEffect } from 'react';
import store, { templatesAction } from '@apply/adminStore';
import Dialog from '@material-ui/core/Dialog';
import { TemplatesApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { useSelector } from 'react-redux';
import { RefreshEvents } from '../../common/SharedEvents';

const EditNameModal = () => {
    const { isOpen, templateId, nameText = '' } = useSelector((state) => state.templates.editNameModal);
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);
    const { dispatch } = store;
    const refreshEvents = new RefreshEvents();

    const [name, set_name] = useState('');

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        buttonMarginRight: {
            marginRight: '20px',
        },
        modal: {
            width: 600,
        },
        content: {
            height: 'auto',
            padding: '10px',
        },
    };

    const handleClose = () =>
        dispatch(
            templatesAction.setEditNameModal({
                editNameModal: { isOpen: false },
            })
        );

    useEffect(() => {
        set_name(nameText);
    }, [nameText]);

    const _onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const model = {
            templateId: templateId,
            name,
        };

        await templatesApi.saveTemplateName(model);

        refreshEvents.dispatchRefreshEvent();
        handleClose();
    };

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <form
                            name='brokerForm'
                            onSubmit={(event) => _onSubmit(event)}
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1>Edit Notes</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={handleClose}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <div className='main-content no-search'>
                                <div
                                    className='scrollable-content'
                                    style={styles.content}
                                >
                                    <div className='standard-form'>
                                        <div
                                            className='row'
                                            style={{ marginBottom: '0' }}
                                        >
                                            <div className='columns small-6 large-12 end'>
                                                <label htmlFor='templateName'>
                                                    Template Name
                                                    <span className='req'>*</span>
                                                </label>
                                                <input
                                                    id='templateName'
                                                    type='text'
                                                    maxLength={100}
                                                    value={name}
                                                    onChange={(event) => set_name(event.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='button-footer'
                                        style={styles.buttonContainer}
                                    >
                                        <button
                                            style={styles.buttonMarginRight}
                                            type='submit'
                                            className='button primary'
                                            title='Save changes and close'
                                        >
                                            Save
                                        </button>
                                        &nbsp;
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={handleClose}
                                            title='Abandon changes and close'
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default EditNameModal;
